import { render } from "./NewCompanyModal.vue?vue&type=template&id=5341ad62"
import script from "./NewCompanyModal.vue?vue&type=script&lang=js"
export * from "./NewCompanyModal.vue?vue&type=script&lang=js"

import "./NewCompanyModal.vue?vue&type=style&index=0&id=5341ad62&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__